export default "__VITE_ASSET__bWUHc1Vz__"